import React from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { motion, AnimatePresence } from "framer-motion";

interface ErrorMessageProps {
    message: string;
    onClose: () => void;
    fullScreen?: boolean;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({
    message,
    onClose,
    fullScreen = false,
}) => {
    const containerClass = fullScreen
        ? "fixed inset-0 flex items-center justify-center z-50 bg-black/40 backdrop-blur-sm"
        : "absolute inset-0 flex items-center justify-center z-10 bg-black/40 backdrop-blur-sm rounded-lg";

    return (
        <AnimatePresence>
            <motion.div
                className={containerClass}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.2 }}>
                <motion.div
                    className="bg-white p-8 rounded-2xl shadow-2xl max-w-md w-full flex flex-col items-center mx-4"
                    initial={{ scale: 0.9, y: 20, opacity: 0 }}
                    animate={{ scale: 1, y: 0, opacity: 1 }}
                    transition={{
                        duration: 0.3,
                        delay: 0.1,
                    }}>
                    <motion.div
                        className="w-48 h-48 mb-6"
                        initial={{ y: 20, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ delay: 0.2 }}>
                        <DotLottieReact
                            src="https://lottie.host/b53cfe5f-97bb-459d-86b2-f9838448ee80/WtOO1WOLfk.lottie"
                            loop
                            autoplay
                            speed={0.5}
                        />
                    </motion.div>

                    <motion.div
                        className="text-center space-y-4"
                        initial={{ y: 20, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ delay: 0.3 }}>
                        <h3 className="text-red-600 font-bold text-2xl mb-2">
                            ❌ Error Occurred
                        </h3>
                        <div className="bg-red-50 border border-red-100 rounded-lg p-4">
                            <p className="text-gray-800 text-lg">{message}</p>
                        </div>
                    </motion.div>

                    <motion.button
                        initial={{ y: 20, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ delay: 0.4 }}
                        onClick={onClose}
                        className="mt-8 text-white bg-blue-600 hover:bg-blue-700 px-8 py-3 rounded-lg font-medium transition-all duration-200 hover:shadow-lg active:scale-95 text-base min-w-[140px]">
                        Close
                    </motion.button>
                </motion.div>
            </motion.div>
        </AnimatePresence>
    );
};

export default ErrorMessage;
